/** Mirror of backend `com.kervolt.oms.enums.StyleStatus` (garments-merchandising T3). */
export type StyleStatus = 'DEVELOPMENT' | 'QUOTED' | 'CONFIRMED' | 'ARCHIVED';

/** Mirror of backend `com.kervolt.oms.enums.StyleCostCategory`. */
export type StyleCostCategory = 'FABRIC' | 'TRIM' | 'CM' | 'COMMERCIAL' | 'OTHER';

/** Mirror of backend `com.kervolt.oms.enums.StyleDocumentKind`. */
export type StyleDocumentKind = 'TECH_PACK' | 'MEASUREMENT_CHART' | 'ARTWORK' | 'SPEC_SHEET' | 'PHOTO' | 'OTHER';

/** Labels for `StyleDocumentKind`, in display order — used for the upload Kind select and the
 *  attachments Tabs strip (merch-commercial close-out T4). */
export const STYLE_DOCUMENT_KINDS: { value: StyleDocumentKind; label: string }[] = [
    { value: 'TECH_PACK', label: 'Tech pack' },
    { value: 'MEASUREMENT_CHART', label: 'Measurement chart' },
    { value: 'ARTWORK', label: 'Artwork' },
    { value: 'SPEC_SHEET', label: 'Spec sheet' },
    { value: 'PHOTO', label: 'Photo' },
    { value: 'OTHER', label: 'Other' },
];

/** Mirror of backend `StyleCostLineDTO`. */
export interface IStyleCostLine {
    id: string;
    category: StyleCostCategory;
    description: string;
    quantity?: number | null;
    uom?: string | null;
    unitCost?: number | null;
    amount: number;
    sortOrder: number;
}

/** Mirror of backend `StyleCostLineRequest` — `amount` is server-computed, never sent. */
export interface IStyleCostLineRequest {
    category: StyleCostCategory;
    description: string;
    quantity?: number | null;
    uom?: string | null;
    unitCost?: number | null;
    sortOrder?: number | null;
}

/** Mirror of backend `StyleDTO`. `costLines`/`totalCost`/`estimatedMarginPct` are server-computed on every read. */
export interface IStyle {
    id: string;
    institutionId: string;
    buyerId: string;
    styleNumber: string;
    name: string;
    buyerStyleRef?: string | null;
    garmentType?: string | null;
    season?: string | null;
    sizeRange?: string | null;
    fabricDescription?: string | null;
    constructionNotes?: string | null;
    targetFobPrice?: number | null;
    currencyCode?: string | null;
    status: StyleStatus;
    active: boolean;
    hsCode?: string | null;
    costLines: IStyleCostLine[];
    totalCost: number;
    estimatedMarginPct?: number | null;
    createdAt: string;
    updatedAt: string;
}

/** Mirror of backend `CreateStyleRequest`. */
export interface ICreateStyleRequest {
    buyerId: string;
    styleNumber: string;
    name: string;
    buyerStyleRef?: string | null;
    garmentType?: string | null;
    season?: string | null;
    sizeRange?: string | null;
    fabricDescription?: string | null;
    constructionNotes?: string | null;
    targetFobPrice?: number | null;
    currencyCode?: string | null;
    hsCode?: string | null;
}

/** Mirror of backend `UpdateStyleRequest` — `buyerId` null means "unchanged". */
export type IUpdateStyleRequest = ICreateStyleRequest;

/** Mirror of backend `StyleAttachmentDTO`. */
export interface IStyleAttachment {
    id: string;
    styleId: string;
    fileName: string;
    contentType?: string | null;
    sizeBytes?: number | null;
    uploadedByUserId?: string | null;
    documentKind: StyleDocumentKind;
    versionNo: number;
    revisionLabel?: string | null;
    notes?: string | null;
    latestForKind: boolean;
    createdAt: string;
}

export interface IStylePage {
    content: IStyle[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}
